import React, { useState } from "react";
import { motion } from "framer-motion";
import logo from "../Assets/HerVeg.png";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import supabase from "../Config/Supabase";
import landscape from "../Assets/landscapes.png";

const PasswordReset = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const { error } = await supabase.auth.resetPasswordForEmail(email);
    if (error) {
      toast.error(`Error: ${error.message}`);
      setIsSubmitting(false);
    } else {
      setIsSubmitting(false);
      toast.success("Password reset link has been sent to your email.");
    }
  };

  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden bg-[#f5f7f2] dark:bg-[#0e1410]">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 pointer-events-none">
        <svg
          className="absolute top-0 left-0 w-full h-full opacity-[0.03] dark:opacity-[0.06]"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <pattern
              id="grid"
              width="48"
              height="48"
              patternUnits="userSpaceOnUse"
            >
              <path
                d="M 48 0 L 0 0 0 48"
                fill="none"
                stroke="#1a4a2e"
                strokeWidth="1"
              />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>

        {/* Decorative blobs */}
        <motion.div
          animate={{ scale: [1, 1.05, 1], rotate: [0, 5, 0] }}
          transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
          className="absolute -top-32 -right-32 w-[480px] h-[480px] rounded-full bg-green-200/30 dark:bg-green-900/20 blur-3xl"
        />
        <motion.div
          animate={{ scale: [1, 1.08, 1], rotate: [0, -5, 0] }}
          transition={{
            duration: 15,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 2,
          }}
          className="absolute -bottom-40 -left-24 w-[400px] h-[400px] rounded-full bg-emerald-200/25 dark:bg-emerald-900/15 blur-3xl"
        />
      </div>

      {/* landscape image */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute bottom-0 left-0 right-0">
          <img
            src={landscape}
            alt="Herveg05 farm illustration"
            className="object-cover opacity-85"
          />
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md p-8 space-y-6"
      >
        <img alt="makazihub logo" src={logo} className="w-auto h-24 mx-auto" />

        <h2 className="text-xl font-medium dark:text-gray-300 font-raleway text-blue-950">
          Reset Your Password
        </h2>

        <form onSubmit={handlePasswordReset} className="space-y-4">
          <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            <label
              htmlFor="email"
              className="block text-sm font-medium leading-6 text-gray-900 md:text-md dark:text-gray-400"
            >
              Email address
            </label>

            <div className="mt-2">
              <motion.input
                initial={{ opacity: 0, width: 0 }}
                animate={{ opacity: 1, width: "100%" }}
                whileFocus={{ width: [0, "100%"] }}
                transition={{
                  duration: 0.5,
                  ease: "easeInOut",
                }}
                id="email"
                name="email"
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                required
                autoComplete="email"
                className="block w-full px-1 py-2 text-gray-900 border-b-2 border-green-600 outline-none bg-inherit placeholder:text-gray-400 sm:text-sm sm:leading-6"
              />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 100 }}
            animate={{ opacity: 1, y: 1 }}
            transition={{ delay: 0.3, duration: 0.5 }}
          >
            <motion.button
              type="submit"
              disabled={isSubmitting}
              whileTap={{ scale: 0.95 }}
              className="w-full px-4 py-1 mb-4 font-bold text-white bg-green-600 rounded-md cursor-pointer hover:bg-green-500 disabled:bg-gray-400"
            >
              {isSubmitting ? "Sending..." : "Send Password Reset Link"}
            </motion.button>
          </motion.div>
        </form>
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
          className="flex flex-col w-full"
        >
          <Link
            to={"/"}
            className="text-base text-right text-blue-700 dark:text-gray-200"
          >
            Log-in
          </Link>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default PasswordReset;
